<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<nav class="navbar navbar-expand-lg fixed-top bg-primary" data-bs-theme="light">
  <a class="navbar-brand" href="#">Surface Elements</a>
  <button
    class="navbar-toggler"
    type="button"
    (click)="isMenuCollapsed = !isMenuCollapsed"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="container-fluid pe-0">
    <div class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
      @if (isAuthenticated()) {
        <ul class="navbar-nav me-auto">
          <li [routerLinkActive]="['active']" class="nav-item">
            <a
              class="nav-link"
              routerLink="/accounts"
              (click)="isMenuCollapsed = true"
              >Accounts</a
            >
          </li>
          <li [routerLinkActive]="['active']" class="nav-item">
            <a
              class="nav-link"
              routerLink="/jobs"
              (click)="isMenuCollapsed = true"
              >Jobs</a
            >
          </li>
          <li [routerLinkActive]="['active']" class="nav-item">
            <a
              class="nav-link"
              routerLink="/orders"
              (click)="isMenuCollapsed = true"
              >Orders</a
            >
          </li>
          <li [routerLinkActive]="['active']" class="nav-item">
            <a
              class="nav-link"
              routerLink="/contacts"
              (click)="isMenuCollapsed = true"
              >Contacts</a
            >
          </li>
          <li [routerLinkActive]="['active']" class="nav-item">
            <a
              class="nav-link"
              routerLink="/reports"
              (click)="isMenuCollapsed = true"
              >Reports</a
            >
          </li>
          @if (user()?.roles?.includes('ADMIN')) {
            <li [routerLinkActive]="['active']" class="nav-item">
              <a
                class="nav-link"
                routerLink="/settings"
                (click)="isMenuCollapsed = true"
                >Settings</a
              >
            </li>
          }
        </ul>
      }
      <div class="mx-2 search-wrapper flex-grow-1">
        @if (isAuthenticated()) {
          <app-widget-search-bar></app-widget-search-bar>
        }
      </div>
      <div>
        <ul class="navbar-nav profile-section">
          @if (!isAuthenticated()) {
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/login"
                (click)="isMenuCollapsed = true"
                >Login</a
              >
            </li>
          }
          @if (isAuthenticated() && !showProfileMenu()) {
            <div>
              <div class="profile-name text-nowrap">
                {{ user()?.firstName }} {{ user()?.lastName }}
              </div>
              <li class="nav-item">
                <a
                  class="nav-link pt-0"
                  style="cursor: pointer"
                  (click)="logOut()"
                  >LogOut</a
                >
              </li>
            </div>
          }
          @if (isAuthenticated() && showProfileMenu()) {
            <li class="nav-item" ngbDropdown data-testid="profile-dropdown">
              <a
                class="nav-link"
                style="cursor: pointer; white-space: nowrap"
                ngbDropdownToggle
              >
                {{ user()?.firstName }} {{ user()?.lastName }}
              </a>
              <div ngbDropdownMenu class="dropdown-menu-end">
                @if (showAdminItems()) {
                  <div data-testid="menu-admin-section">
                    <h6 class="dropdown-header">Admin</h6>
                    <a
                      ngbDropdownItem
                      routerLink="/dev-admin/feature-flags"
                      (click)="isMenuCollapsed = true"
                      data-testid="menu-feature-flags"
                      >Feature Flags</a
                    >
                    <a
                      ngbDropdownItem
                      routerLink="/dev-admin/users"
                      (click)="isMenuCollapsed = true"
                      data-testid="menu-user-management"
                      >User Management</a
                    >
                    <div class="dropdown-divider"></div>
                  </div>
                }
                <a
                  ngbDropdownItem
                  style="cursor: pointer"
                  (click)="logOut(); isMenuCollapsed = true"
                  data-testid="menu-logout"
                  >LogOut</a
                >
              </div>
            </li>
          }
        </ul>
      </div>
      @if (isAuthenticated()) {
        <div class="mx-2 d-none d-lg-block">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="profile-icon bi bi-person-circle"
            width="30"
            height="30"
            fill="#fff"
            viewBox="0 0 16 16"
          >
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
            <path
              fill-rule="evenodd"
              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
            />
          </svg>
        </div>
      }
    </div>
  </div>
</nav>
